import { QueueIcon, queueIconColor } from '@/components/QueueIcon'

/**
 * Customer profile art on Messages and its embedded thread surfaces. A stable
 * customer/conversation seed selects one of the eight Corpus clay colorways.
 */
export function ConversationAvatar({
  seed,
  className,
}: {
  seed: string
  name?: string | null
  phone?: string | null
  className?: string
}) {
  return <QueueIcon meaning="customer" color={queueIconColor(seed)} className={className} />
}
